var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourcesClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 24",
    style: {
      enableBackground: "new 0 0 19 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,3.4c4,0,7.3,3.2,7.3,7.2c0,3.9-3.3,7.2-7.3,7.2c-4.1,0-7.3-3.2-7.3-7.2C3.5,6.6,6.8,3.4,10.8,3.4z  M2.6,10.5c0,4.4,3.7,8,8.2,8s8.2-3.6,8.2-8c0-4.4-3.7-8-8.2-8S2.6,6.1,2.6,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.7,19.9l0.4,0.8l0.8-0.4L15.7,18l-0.8,0.4l0.4,0.7c-1.4,0.7-2.9,1.1-4.5,1.1c-5.5,0-9.9-4.3-9.9-9.7 c0-3.6,2.1-7,5.4-8.6l0.4,0.8l0.8-0.4L6.3,0L5.5,0.4l0.4,0.8C2.3,2.9,0,6.6,0,10.5C0,16.2,4.6,20.8,10.4,21v1.3 c-2,0.1-3.8,0.7-5.4,1.7h1.8c1.2-0.5,2.6-0.8,4-0.8c1.4,0,2.8,0.3,4,0.8h1.8c-1.6-1-3.5-1.6-5.4-1.7V21 C12.8,21,14.3,20.6,15.7,19.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesClicked);
export default __webpack_public_path__ + "static/media/sources_clicked.145beb6f2df2a454812bf721388ae1a9.svg";
export { ForwardRef as ReactComponent };